import './styles.scss'

import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import useEvent from 'src/hooks/useEvent'
import useHub from 'src/hooks/useHub'
import { isTGACustomer } from 'src/utils/specialCustomers'

const Footer = () => {
  const { t } = useTranslation('footer')
  const history = useHistory()

  // const id = history.location.pathname.split('/events/')[1]?.split('?')[0].split('/')[0]
  // const { event } = useEvent(id, {
  //   retry: 0,
  //   enabled:
  //     id != null && id !== 'list' && id !== 'upcoming' && id !== 'past' && id !== 'favorites' && id !== 'unfinished',
  // })

  // const clubId = history.location.pathname.split('/clubs/')[1]?.split('?')[0].split('/')[0]

  // let hubId = history.location.pathname.split('/hubs/')[1]?.split('?')[0].split('/')[0]
  // if (id != null && hubId == null) {
  //   hubId = document.referrer?.split('/hubs/')[1]?.split('?')[0].split('/')[0]
  // }
  // const { hub } = useHub({ id: hubId }, { retry: 0, enabled: hubId != null })

  const isTwilightFacilityRoute = /^\/facilities\//.test(history.location.pathname)
  let isFooterHidden =
    ['preview-event', 'test'].some((route) => history.location.pathname.includes(route)) || window
      ? 'parentIFrame' in window
      : false

  // if (!isFooterHidden) {
  //   isFooterHidden = isTGACustomer(hub?.id) || isTGACustomer(clubId) || isTGACustomer(event?.customer_id)
  // }

  const GOLFGENIUS_URL = process.env.REACT_APP_BASE_URL == 'prod' ? 'https://www.golfgenius.com' : 'https://ggstest.com'

  return (
    <Fragment>
      <footer className="golf-footer" style={{ display: isTwilightFacilityRoute || isFooterHidden ? 'none' : 'block' }}>
        <div className="golf-container d-flex flex-wrap flex-col items-center sm_tablet:pb-40">
          <div className="golf-footer__logo--orange"></div>
          <ul className="golf-footer__links-wrapper">
            <li>
              <a href={`${GOLFGENIUS_URL}/terms_conditions`} className="golf-footer__link text-16 sm_desktop:text-19">
                <span>{t('links.termsOfService')}</span>
              </a>
            </li>
            <span className="d-none sm_tablet:d-block mt-10">|</span>
            <li>
              <a href={`${GOLFGENIUS_URL}/privacy`} className="golf-footer__link text-16 sm_desktop:text-19">
                <span>{t('links.privacyPolicy')}</span>
              </a>
            </li>
          </ul>
        </div>
        <small className="d-none sm_tablet:d-block text-right text-dark-grey">
          {t('copyright', { year: new Date().getFullYear() })}
        </small>
      </footer>
    </Fragment>
  )
}

export default Footer
